const injectClientSideOnlyPolyfills = (): void => {
  require('focus-visible') // eslint-disable-line global-require
}

export default injectClientSideOnlyPolyfills